export const LOAD_PRODUCTS = "LOAD_PRODUCTS";
export const ADD_TO_CART = "ADD_TO_CART";
export const DELETE_FROM_CART = "DELETE_FROM_CART";
export const ADJUST_QUANTITY = "ADJUST_QUANTITY";
export const LOAD_CURRENT_ITEM = "LOAD_CURRENT_ITEM";
export const CLEAR_CART = "CLEAR_CART";
export const SAVE_ORDER_NUMBER = "SAVE_ORDER_NUMBER";
export const LOAD_ORDER_NUMBER = "LOAD_ORDER_NUMBER";